var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWeldingMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.08,5a9.72,9.72,0,0,1,2.32.53c.89.24,1.75.6,2.65.75,4.66.74,8.8,2.46,11.92,6.17A16.87,16.87,0,0,1,47.41,20,17.75,17.75,0,0,1,45.15,33,21.34,21.34,0,0,0,42.29,44c0,1,0,2,0,3.05a3.61,3.61,0,0,1-3.05,3.68A12.3,12.3,0,0,1,37,51c-3.81,0-7.62,0-11.44,0-2.49,0-3.67-.83-4.63-3.16-.08-.19-.2-.37-.35-.64H17.4c-.77,0-1.53,0-2.29,0-3.72-.07-5.91-2.17-6.06-5.9C9,39.63,9,38,9,36.32v-4.9H9V25c.56,0,1-.09,1.45-.1,1.86,0,3.73,0,5.59,0s2.24-.46,2.24-2.26c0-1.61,0-3.22,0-4.83a8.93,8.93,0,0,0-.14-1.64c-.24-1.32-.72-1.71-2.07-1.72l-6.61,0a2.47,2.47,0,0,1-.42-.13c0-1.87-.31-3.8.37-5.69A5.29,5.29,0,0,1,14.49,5Q20.79,5,27.08,5ZM45.82,24.51H32.53v1.74c0,5,0,9.92,0,14.88,0,3.69-2.23,5.92-5.92,6-.89,0-1.78,0-2.67,0-.33,0-.66.05-1,.07A2,2,0,0,0,25.2,49q6.24,0,12.47,0a4.86,4.86,0,0,0,1.13-.14A1.77,1.77,0,0,0,40.32,47c0-.72,0-1.44,0-2.16A25.3,25.3,0,0,1,43.85,31.2a15.84,15.84,0,0,0,1.89-5.5C45.8,25.34,45.79,25,45.82,24.51ZM10.92,38.33a1,1,0,0,0-.93,1,.89.89,0,0,0,1,.84.84.84,0,0,0,.83-.91A.88.88,0,0,0,10.92,38.33Zm2.76,0a.92.92,0,0,0-.06,1.84c.61,0,.91-.31,1-.92A.92.92,0,0,0,13.68,38.34Zm2.74,0a.92.92,0,1,0,.06,1.84.81.81,0,0,0,.89-.8A1,1,0,0,0,16.42,38.34Zm.46-22.87a3.38,3.38,0,0,1,.42,1.09c0,2.36,0,4.73,0,7.05-1,.5-5.82.66-8.22.29V22.57h5.36c1.27,0,1.61-.32,1.64-1.54q0-1.59,0-3.18c0-1.13-.39-1.52-1.55-1.55-1.57-.05-3.13,0-4.7,0H9.14c0-.27,0-.5-.05-.82ZM32.33,8.55c.07,1.32.17,2.62.19,3.92,0,2.12,0,4.23,0,6.35a9.15,9.15,0,0,0,.1,1H45.24C44.38,13.91,37.29,7.83,32.33,8.55Z",
    fill: "#0A0D0D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeldingMask);
export default __webpack_public_path__ + "static/media/welding-mask.4fc4abdd.svg";
export { ForwardRef as ReactComponent };